import React from 'react';
import { ApolloError } from '@apollo/client';
import { Card } from '@mui/material';

import { LoadedContent } from '@occc/ui-design-system';
import { SitesSummaryItemFragment } from '@occc/graphql';

import LocationsSummaryItem from './LocationsSummaryItem';

interface LocationsSummaryProps {
  data?: SitesSummaryItemFragment | null;
  error?: ApolloError;
  loading: boolean;
}

type SummaryDataItem = {
  value: number;
  label: string;
  color: string;
};

const LocationsSummary: React.FunctionComponent<LocationsSummaryProps> = ({
  data,
  error,
  loading,
}) => {
  const getItems = (): SummaryDataItem[] | null => {
    if (data) {
      return [
        {
          value: data.total,
          label: 'Locations',
          color: 'success.main',
        },
        {
          value: data.loyaltyOnline,
          label: 'Loyalty Online',
          color: 'success.main',
        },
        {
          value: data.loyaltyOffline,
          label: 'Loyalty Offline',
          color: 'error.main',
        },
        {
          value: data.mobileOnline,
          label: 'Mobile Online',
          color: 'success.main',
        },
        {
          value: data.mobileOffline,
          label: 'Mobile Offline',
          color: 'error',
        },
        {
          value: data.issues,
          label: 'Open Issues',
          color: 'error',
        },
      ];
    }

    return null;
  };

  const renderData = () => (
    <Card
      sx={() => ({
        py: 2,
        px: 0,
        mb: 1,
        display: 'flex',
        alignItems: 'center',
      })}
    >
      {getItems()?.map(({ value, label, color }, index) => (
        <LocationsSummaryItem key={index} value={value} label={label} color={color} />
      ))}
    </Card>
  );

  return (
    <LoadedContent<SummaryDataItem>
      loading={loading}
      error={error}
      items={getItems()}
      renderData={renderData}
    />
  );
};

export default LocationsSummary;
